/* eslint-disable */
export const handleUrl = (multiPayUrl, callback) => {
  const title = 'MULTIPAY';
  const h = 675;
  const w = 775;
                   
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    window.screen.width;

  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.documentElement.clientHeight ||
    window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    multiPayUrl,
    title,
    `scrollbars=yes, width=${w / systemZoom}, height=${
      h / systemZoom
    }, top=${top}, left=${left}`
  );

  var timer = setInterval(function () {
    if (newWindow.closed) {
      clearInterval(timer);
      if (callback) callback();
    }
  }, 1000);

  if (window.focus && newWindow) newWindow.focus();
};

export const dummy = () => {};
